import './legacy/navigation';
import './legacy/skip-link-focus-fix';
import './legacy/file-download';
import './legacy/location-load-more';
import './legacy/search.js';
import './legacy/subnav-reload';
import './legacy/subnav';
import './legacy/sort-articles';
import './legacy/slick';
import './legacy/embedded-forms';
import './legacy/stacked-slider';
import './legacy/tabs';

import { initA11yDialog } from './legacy/dialog.js';
import { initGroupLoadmore } from './legacy/group-loadmore.js';

(function ($) {
    initA11yDialog();
    initGroupLoadmore();
})(window.jQuery);
